import appendMinuteTimestamp from './appendMinuteTimestamp';
const getConfig = async () => {
  try {
    const response = await fetch(
      appendMinuteTimestamp(
        //'https://widget.buyercall.com/dealercom/config/dealerConfig.json',
        //'https://gctest.offerlogix.net/dealercom/config/dealerConfig.json',
        'https://widget.mycreditdriveapp.com/dealercom/config/dealerConfig.json',
      ),
      // appendMinuteTimestamp('http://localhost:3005/test.json'),
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log('dealer config fetch error', error);
    return {}; 
  }
};


export default getConfig;
